import React from 'react';
import css from './BusinessDevelopmentFormFields.module.css';
import { FormattedMessage } from 'react-intl';

import TitleInputField from '../TitleInputField';
import PriceInputField from '../PriceInputField';
import HoursInputField from '../HoursInputField';
import LocationInputFormField from '../LocationInputFormField/LocationInputFormField';
import PersonalizationFormField from '../PersonalizationFormField';
import BookingTimeFormField from '../BookingTimeFormField/BookingTimeFormField';
import classNames from 'classnames';

const BUSINESS_CONFIG = {
  'Networking Sessions': {
    needsLocation: true,
    descriptionLabel: 'Describe the Networking Session',
    descriptionPlaceholder:
      'e.g. 90-minute cocktail-style networking event with 50 executives from sports tech and media...',
  },
  'Corporate Event': {
    needsLocation: true,
    descriptionLabel: 'Describe the Corporate Event',
    descriptionPlaceholder:
      'e.g. Keynote speaker at annual sales conference, employee meet & greet, or VIP hospitality suite appearance...',
  },
  'Panel Discussion Participation': {
    needsLocation: true,
    descriptionLabel: 'Describe the Panel Discussion',
    descriptionPlaceholder:
      'e.g. Join a 45-minute panel on "Athlete Transitions to Business" at the Sports Business Summit. Topic ideas welcome...',
  },
};

const BusinessDevelopmentFormFields = ({ formId, values, listing }) => {
  const selectedTitle = values?.title;
  const config = selectedTitle ? BUSINESS_CONFIG[selectedTitle] : null;
  // Show minimal form until type is selected
  if (!selectedTitle || !config) {
    return (
      <>
        <div className={css.offeringBlock}>
          <div className={css.offeringHeader}>
            <h4>
              <FormattedMessage id="BusinessDevelopmentFormFields.sectionHeading" />
            </h4>
          </div>
        </div>
        <div className={css.formRow}>
          <div className={css.formRow}>
            <TitleInputField label="Type" id="title" fieldName="title" />
          </div>
          <div className={css.formRow}>
            <PriceInputField formId={formId} />
          </div>
        </div>
      </>
    );
  }

  const {
    needsLocation = true, // All current types require location
    descriptionLabel,
    descriptionPlaceholder = 'Provide details about the event, audience, format, and your desired role...',
  } = config;

  return (
    <>
      <div className={css.offeringBlock}>
        <div className={css.offeringHeader}>
          <h4>
            <FormattedMessage id="BusinessDevelopmentFormFields.sectionHeading" />
          </h4>
        </div>
      </div>

      <div className={css.formRow}>
        <div className={css.formFld}>
          {/* Type */}
          <TitleInputField label="Type" id="title" fieldName="title" />
        </div>
        <div className={css.formFld}>
          {/* Price */}
          <PriceInputField formId={formId} />
        </div>
      </div>

      <div className={classNames(css.formRow, css.fullWidth)}>
        <div className={css.formFld}>
          {/* Duration */}
          <HoursInputField
            label="How many hours?"
            fieldName="hours"
            id="hours"
            placeholder="e.g. 2 hours"
          />
        </div>
      </div>
      {/* Booking Time */}
      <BookingTimeFormField listing={listing} />

      <div className={classNames(css.formRow, css.fullWidth)}>
        <div className={classNames(css.formFld, css.fieldGroup)}>
          {/* Location */}
          {needsLocation && (
            <LocationInputFormField
              fieldName="location"
              label="Event Location"
              placeholder="Venue name, address, city (e.g. Hilton Downtown, Chicago)"
            />
          )}
        </div>
      </div>
      {/* Event Description */}
      <PersonalizationFormField
        label={descriptionLabel}
        placeholder={descriptionPlaceholder}
        fieldName="eventDescription"
        rows={5}
      />
    </>
  );
};

export default BusinessDevelopmentFormFields;
